import React from "react";
import Barcode from "react-barcode";
import { QRCodeSVG } from "qrcode.react";

/**
 * Renders a small inline Code128 barcode + QR beside a SKU. Both encode the
 * exact SKU string so a phone or handheld scanner can read either one.
 */
export default function ProductBarcodes({ sku, size = "sm" }) {
  if (!sku) return null;

  const dims = size === "lg"
    ? { barW: 1.6, barH: 34, qr: 56, fontSize: 10 }
    : { barW: 1.0, barH: 22, qr: 34, fontSize: 8 };

  return (
    <div className="flex items-center gap-2 mt-1" data-testid={`barcodes-${sku}`}>
      <div className="bg-white rounded-sm">
        <Barcode
          value={sku}
          format="CODE128"
          width={dims.barW}
          height={dims.barH}
          displayValue={false}
          margin={0}
          background="#ffffff"
          lineColor="#111111"
        />
      </div>
      <div className="bg-white rounded-sm p-0.5">
        <QRCodeSVG value={sku} size={dims.qr} level="M" includeMargin={false} />
      </div>
    </div>
  );
}
